import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CustomerAuthCtx = createContext({
  customer: null,
  loading: true,
  signIn: async () => {},
  signUp: async () => {},
  signOut: () => {},
});

export function CustomerAuthProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("gc_customer_token");
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/customer/me")
      .then((r) => setCustomer(r.data))
      .catch(() => {
        localStorage.removeItem("gc_customer_token");
        localStorage.removeItem("gc_customer");
      })
      .finally(() => setLoading(false));
  }, []);

  const persist = (token, user) => {
    localStorage.setItem("gc_customer_token", token);
    localStorage.setItem("gc_customer", JSON.stringify(user));
    setCustomer(user);
  };

  const signUp = async ({ name, email, password }) => {
    const r = await api.post("/auth/customer/signup", { name, email, password });
    persist(r.data.token, r.data.user);
    return r.data.user;
  };

  const signIn = async ({ email, password }) => {
    const r = await api.post("/auth/customer/login", { email, password });
    persist(r.data.token, r.data.user);
    return r.data.user;
  };

  const signOut = () => {
    localStorage.removeItem("gc_customer_token");
    localStorage.removeItem("gc_customer");
    setCustomer(null);
  };

  return (
    <CustomerAuthCtx.Provider value={{ customer, loading, signIn, signUp, signOut }}>
      {children}
    </CustomerAuthCtx.Provider>
  );
}

export function useCustomerAuth() {
  return useContext(CustomerAuthCtx);
}
